import React from 'react';

const keyframes = `
@keyframes fd-spin {
  to { transform: rotate(360deg); }
}
`;

const Spinner = ({ size = 24, color = '#1976d2', label }) => (
  <>
    <style>{keyframes}</style>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
      <div style={{
        width: size,
        height: size,
        border: `3px solid #e0e0e0`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'fd-spin 0.8s linear infinite'
      }} />
      {label && <div style={{ fontSize: 13, color: '#999' }}>{label}</div>}
    </div>
  </>
);

export const FullPageSpinner = ({ label }) => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 60, width: '100%'
  }}>
    <Spinner size={32} label={label} />
  </div>
);

export const InlineSpinner = ({ size = 16, color = '#1976d2' }) => (
  <>
    <style>{keyframes}</style>
    <span style={{
      display: 'inline-block',
      width: size,
      height: size,
      border: `2px solid #e0e0e0`,
      borderTopColor: color,
      borderRadius: '50%',
      animation: 'fd-spin 0.8s linear infinite',
      verticalAlign: 'middle'
    }} />
  </>
);

export default Spinner;
